import React from 'react';
import './PayFeeOnline.css';

const payPlans = [
  {
    discount: '20% OFF',
    price: '$25/MONTH',
    priceVal: 25,
    original: '$30/month',
    features: [
      '1 Lesson per Week',
      '4 Lessons per Month'
    ]
  },
  {
    discount: '20% OFF',
    price: '$35/MONTH',
    priceVal: 35,
    original: '$42/month',
    features: [
      '2 Lesson per Week',
      '8 Lessons per Month'
    ]
  },
  {
    discount: '20% OFF',
    price: '$45/MONTH',
    priceVal: 45,
    original: '$54/month',
    features: [
      '2 Lessons every Weekend (Sat – Sun)',
      '8 Lessons per Month'
    ]
  },
  {
    discount: '20% OFF',
    price: '$48/MONTH',
    priceVal: 48,
    original: '$58/month',
    features: [
      '3 Lesson per Week',
      '12 Lessons per Month'
    ]
  },
  {
    discount: '20% OFF',
    price: '$64/MONTH',
    priceVal: 64,
    original: '$77/month',
    features: [
      '4 Lesson per Week',
      '16 Lessons per Month'
    ]
  },
  {
    discount: '20% OFF',
    price: '$80/MONTH',
    priceVal: 80,
    original: '$96/month',
    features: [
      '5 Lesson per Week',
      '20 Lessons per Month'
    ]
  }
];

const PayFeeOnline = () => {
  const handleAddToCart = (plan) => {
    localStorage.setItem('cartItem', JSON.stringify({
      name: plan.name,
      price: plan.price,
      original: plan.original,
      priceVal: plan.priceVal,
      features: plan.features,
      quantity: 1
    }));
    // Redirect to cart page using router patch trigger
    window.history.pushState({}, '', '/cart');
    window.dispatchEvent(new PopStateEvent('popstate'));
  };

  return (
    <div className="pay-fee-page">
      {/* Sub Hero Banner */}
      <section 
        className="pay-hero"
        style={{
          backgroundImage: `url('${process.env.PUBLIC_URL}/assets/images/home-banner.jpg')`
        }}
      >
        <div className="pay-hero__container" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <h1 className="pay-hero__title" style={{ marginBottom: '8px' }}>Pay Fee Online</h1>
          <nav className="about-hero__breadcrumb" aria-label="breadcrumb">
            <a href="/" className="about-hero__breadcrumb-link">
              Home
            </a>
            <span className="about-hero__breadcrumb-separator">&gt;</span>
            <span className="about-hero__breadcrumb-current">Pay Fee Online</span>
          </nav>
        </div>
      </section>

      {/* Payment Grid Section */}
      <div className="pay-grid-wrapper">
        <section className="pay-pricing-section">
          <div className="pay-pricing-section__container">
            <h2 className="pay-pricing-section__title">Secure & Instant Payment</h2>
            <p className="pay-pricing-section__subtitle">Pay easily for your classes via our PCI-compliant online payment system</p>

            {/* Pricing Grid */}
            <div className="pay-pricing-section__grid">
              {payPlans.map((plan, index) => (
                <div key={index} className="pay-pricing-card">
                  <div className="pay-pricing-card__discount-row">
                    {plan.discount}
                  </div>
                  
                  <div className="pay-pricing-card__banner">
                    <span className="pay-pricing-card__price-text">{plan.price}</span>
                    <span className="pay-pricing-card__original-text">{plan.original}</span>
                  </div>

                  <ul className="pay-pricing-card__features">
                    {plan.features.map((feature, fIndex) => (
                      <li key={fIndex} className="pay-pricing-card__feature-item">
                        {feature}
                      </li>
                    ))}
                  </ul>

                  <div className="pay-pricing-card__cta">
                    <button 
                      onClick={() => handleAddToCart({
                        name: `Quran Class Package - ${plan.price}`,
                        price: plan.price,
                        original: plan.original,
                        priceVal: plan.priceVal,
                        features: plan.features
                      })}
                      className="pay-pricing-card__btn"
                      style={{ border: 'none', cursor: 'pointer', width: '100%' }}
                    >
                      PAY NOW
                    </button>
                  </div>
                </div>
              ))}
            </div>

            {/* Centered Pay Per Hour Card at Bottom */}
            <div className="pay-pricing-section__bottom-card-container">
              <div className="pay-pricing-card pay-pricing-card--hour">
                <div className="pay-pricing-card__discount-row">
                  20% OFF
                </div>
                
                <div className="pay-pricing-card__banner">
                  <span className="pay-pricing-card__price-text">PAY PER HOUR</span>
                </div>

                <ul className="pay-pricing-card__features">
                  <li className="pay-pricing-card__feature-item">
                    $8 per hour
                  </li>
                  <li className="pay-pricing-card__feature-item">
                    Pay fee based on number of hours
                  </li>
                </ul>

                <div className="pay-pricing-card__cta">
                  <button 
                    onClick={() => handleAddToCart({
                      name: 'Pay Per Hour Package',
                      price: '$8 per hour',
                      original: '$10/hour',
                      priceVal: 8,
                      features: ['$8 per hour', 'Pay fee based on number of hours']
                    })}
                    className="pay-pricing-card__btn"
                    style={{ border: 'none', cursor: 'pointer', width: '100%' }}
                  >
                    PAY NOW
                  </button>
                </div>
              </div>
            </div>

          </div>
        </section>
      </div>
    </div>
  );
};

export default PayFeeOnline;

